<template>
    <div class="news">
      <div class="search">
        <div class="search_box">
          <div v-for="item in search" :class='["search_options_box"]'>
            <span style="width: 100px;">{{item.title}}</span>
            <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getSelectProject(selectValue )">
              <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
            </el-select>
          </div>
          <div class="search_btn_box">
            <button :class='["search_btn","green","icon_btn","clearborder"]' @click="getMessageList()"><span class="el-icon-search"></span>搜索</button>
          </div>
          <!--<div class="add_btn_box">
            <button :class='["add_btn","add","icon_btn","clearborder"]'><span class="icon-9"></span>新增灯杆</button>
            <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="icon-9"></span>批量删除</button>
          </div>-->
        </div>
      </div>
      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th>
              <template>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange"></el-checkbox>
                <!--<div style="margin: 15px 0;"></div>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
                </el-checkbox-group>-->
              </template>
            </th>
            <th>
              <select class="table_select" v-model="selectMessage" @change="getMessageList()">
                <option :value="coupon.id" v-for="coupon in couponList">{{coupon.name}}</option>
              </select>
            </th>
            <th>消息编号</th>
            <th>发件者</th>
            <th>消息类型</th>
            <th>主题</th>
            <th>时间</th>
            <th>操作</th>
            <th>标记星标</th>
          </tr>
          </thead>
          <tbody>
          <tr  v-for="(item,index) in tabledata">
            <td>
              <template>
                <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                  <el-checkbox ></el-checkbox>
                </el-checkbox-group>
              </template>
            </td>
            <td v-if="item.is_read===1">已读</td>
            <td v-else-if="item.is_read===0">未读</td>
            <td>{{item.message_number}}</td>
            <td>{{item.create_by}}</td>
            <td v-if="item.type==='0'">系统消息</td>
            <td v-else-if="item.type==='1'">故障警告消息</td>
            <td v-else-if="item.type==='2'">报废提醒消息</td>
            <td>{{item.subject}}</td>
            <td>{{item.create_datetime}}</td>
            <td class="table_btn_box">
              <el-button type="text" @click="getMoreMessage(item.id)" class="table_btn" style="height: 36px">详情</el-button>
              <el-popconfirm title="确定本条消息删除吗？">
                <el-button slot="reference" class="table_btn" @click="deleteMessage(item.id)"  style="height: 36px">删除</el-button>
              </el-popconfirm>
            </td>
            <td v-if="item.is_marked == 0"><img @click="updateStar(item.id)" style="width: 22px;" src="../../../static/img/star/gray.svg"></td>
            <td v-else-if="item.is_marked == 1"><img @click="updateStar(item.id)" style="width: 22px;" src="../../../static/img/star/yellow.svg"></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>1</span>/<span>5</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
    </div>
</template>

<script>
  const cityOptions = [];
    export default {
        name: "news",
      data() {
        return {
          checkAll: false,
          checkedCities: [],
          cities: cityOptions,
          isIndeterminate: true,
          selectMessage:'',
          couponList:[
            {
              id: '',
              name: '全部'
            },
            {
              id: '1',
              name: '已读'
            },
            {
              id: '0',
              name: '未读'
            }
          ],
          search: [
            {
              title: '选择项目',
              options: [],
            },
          ],
          selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
          projectList:[],
          tabledata: [],
          MessageList:[],
          timer: "",
        }
      },
      methods: {
        //多选按钮
        handleCheckAllChange(val) {
          console.log(val)
          this.checkedCities = val ? cityOptions : [];
          this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
          let checkedCount = value.length;
          this.checkAll = checkedCount === this.cities.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
        },

        //修改标记星标的状态
        updateStar: function(id) {
          fetch("/api/v1/message/sign", {
            method: 'post',
            body: JSON.stringify({
              "message_id": id
            })
          }).then(resp => {
            this.timer = setTimeout(this.getMessageList,1000);
          }).catch(error => {
            alert("失败！");
          })
        },

        deleteMessage:function(id){
          fetch("/api/v1/message/delete", {
            method: 'post',
            body: JSON.stringify({
              "message_id": [id]
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "消息删除成功";
                alert(this.message);
                this.getMessageList();
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },

        getMoreMessage:function(id){
          fetch("/api/v1/message/info", {
            method: 'post',
            body: JSON.stringify({
              "message_id": id
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "详情获取成功";
                this.MessageList = data.content;
                this.open(this.MessageList);
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },

        open(message) {
          this.$alert(message, '消息详情', {
            confirmButtonText: '确定',
            // callback: action => {
            //   this.$message({
            //     type: 'info',
            //     message: 'action: ${ action }'
            //   });
            // }
          });
        },


        //获取项目列表
        getProjectList: function () {
          fetch("/api/v1/project/list", {
            method: 'post',
            body: JSON.stringify({})
          })
            .then(result => {
              return result.json();//解析流
            })
            //.then(data => console.log(data))
            .then(data => {
              if (data.code == "200") {
                this.message = "项目数据获取成功";
                this.projectList = data.data;
                let options = this.search[0].options;
                for (let i = 0; i < this.projectList.length; i++) {
                  let projectObj = {};
                  projectObj.label = this.projectList[i].name;
                  projectObj.value = this.projectList[i].id;
                  options.push(projectObj);
                };
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },


        //获取消息列表
        getMessageList: function () {
          fetch("/api/v1/message/list", {
            method: 'post',
            body: JSON.stringify({
              "page_start": 0,
              "page_size": 10,
              "project_id": this.selectValue,
              "is_read": this.selectMessage
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              if (data.code == "200") {
                this.message = "消息列表获取成功";
                this.tabledata = data.data;
              } else {
                this.message = "数据更新异常，请重试";
              }
            })
            .catch((error) => {
              this.message = "网络异常，请重试";
              this.msg_show = !this.msg_show;
            });
        },

      },
      mounted() {
        this.getProjectList();
        this.getMessageList();
      },
    }
</script>

<style scoped>
  .news{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .table_content{
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }
  .table_select{
    background: transparent;
    border: transparent;
    outline: transparent;
    color: #FFFFFF;
    padding: 5px 10px;
  }
  .table_select>option{
    color: #000000;
  }
</style>



// WEBPACK FOOTER //
// src/components/05Management/4_news.vue